import { motion } from 'framer-motion';
import { NEONVERSE } from '../constants';

const NeonDifference = () => (
  <section className="nv-section nv-diff" id="difference">
    <div className="nv-container">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.55 }}
      >
        <p className="nv-eyebrow">Difference</p>
        <h2 className="nv-title">What Makes Us Different</h2>
        <ul className="nv-diff__list">
          {NEONVERSE.difference.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </motion.div>
    </div>
  </section>
);

export default NeonDifference;
